import { SettingsUserLocationAssignmentContainer } from 'modules/settings/pods/settings-user-location-assignment/settings-user-location-assignment.container';

export const SettingsUserLocationAssignmentScene = () => <SettingsUserLocationAssignmentContainer />;

export default SettingsUserLocationAssignmentScene;
